import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {ProleisObject} from "proleis-rest-client";
import {Observable} from "rxjs";
import {Store} from "@ngrx/store";
import {ProleisForMobileState} from "../../../../store/store.index";
import {PlanningActions} from "../../../../store/planning/planning.index";
import {selectUserBookings} from "../../../../store/planning/planning.selectors";
import {map} from "rxjs/operators";

@Component({
  selector: 'p4m-latest-trackings',
  templateUrl: './latest-trackings.component.html',
  styleUrls: ['./latest-trackings.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LatestTrackingsComponent implements OnInit {

  @Input()
  userId: string | undefined;

  @Input()
  trackingDate: Date | undefined;

  filterMode: 'last12' | 'trackingDate' = 'last12';

  trackings$: Observable<ProleisObject[]> = this.store.select(selectUserBookings);
  resources$ = this.trackings$.pipe(
    map(trackings => {
      const mapped = trackings.map(tracking => String(tracking.RES_GRP_NAME));
      return [...new Set(mapped)]
    })
  )

  constructor(private store: Store<ProleisForMobileState>) {
  }

  ngOnInit() {
    this.filterMode = localStorage.getItem('p4m.latestTrackings.filterMode') as 'last12' | 'trackingDate' || 'last12';
    console.log('filterMode set:', this.filterMode);
  }

  public loadTrackings() {
    const aliasFields = 'LEISTUNGSART=SERVICE_TYPE_ID.TEXT;WERTUNGSART=TAETIGKEIT_ID.TEXT;';
    let filterStart: Date;
    if (this.filterMode === 'last12') {
      filterStart = new Date(new Date().setHours(0, 0, 0));
      filterStart.setHours(filterStart.getHours() - 12);
    } else {
      filterStart = new Date(this.trackingDate.setHours(0, 0, 0));
    }

    let filterEnd: Date;
    if (this.filterMode === 'last12') {
      filterEnd = new Date();
    } else {
      filterEnd = new Date(this.trackingDate.setHours(23, 59, 59));
    }

    this.store.dispatch(PlanningActions.loadUserBookings({
      userId: this.userId,
      start: filterStart,
      end: filterEnd,
      aliasFields
    }));
  }

  getMachineBookings(trackings: ProleisObject[], ressource: string) {
    return trackings.filter(tracking => tracking.IST_MANNLOS && tracking.RES_GRP_NAME === ressource);
  }

  getUserBookings(trackings: ProleisObject[], ressource: string) {
    return trackings.filter(tracking => !tracking.IST_MANNLOS && tracking.RES_GRP_NAME === ressource);
  }

  getSum(trackings: ProleisObject[], ressource: string) {
    const mapped = trackings.map(tracking => tracking.STUNDEN);
    if (mapped && mapped.length > 0) {
      return mapped.reduce((sum, tracking) => {
        return sum + tracking;
      })
    }

    return 0;
  }

  onToggleChanged(event: string) {
    localStorage.setItem('p4m.latestTrackings.filterMode', event);
  }

}
